import { Helmet } from 'react-helmet-async';
import { useMemo } from 'react';

const DomainHead = () => {
    const currentDomain = useMemo(() => window.location.hostname, []);
  
    const domainScripts = {
      'app.mozenscrap.ru': () => (
        <>
          <script>{`
                (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                ym(100742659, "init", {
                        clickmap:true,
                        trackLinks:true,
                        accurateTrackBounce:true,
                        webvisor:true
                });
          `}</script>
          <noscript>{`<div><img src="https://mc.yandex.ru/watch/100742659" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
        </>
      ),
      'app.mozenauto.ru': () => (
        <>
        <script>{`
               (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
              k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
              (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

              ym(100742678, "init", {
                      clickmap:true,
                      trackLinks:true,
                      accurateTrackBounce:true,
                      webvisor:true
              });
        `}</script>
        <noscript>{`<div><img src="https://mc.yandex.ru/watch/100742678" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
      </>
      ),
      'localhost': () => (
        <>
        </>
      ),
      'bropays.mozen.io': () => (
        <>
        </>
      ),
      'default': () => (
        <>
          <script>{`
                (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                ym(100742700, "init", {
                        clickmap:true,
                        trackLinks:true,
                        accurateTrackBounce:true,
                        webvisor:true
                });

          `}</script>
          <noscript>{`<div><img src="https://mc.yandex.ru/watch/100742700" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
        </>
      ),
    };
  
    const getDomainContent = () => {
        const domainContent = domainScripts[currentDomain] || domainScripts['default'];
        return domainContent();
      };
  
    return <Helmet>{getDomainContent()}</Helmet>;
  };
  
  export default DomainHead;